import React from "react";
import {RadioGroupKeyValue} from "./radioGroupKeyValue";
import {DateObservable} from "../dateObservable";
import {BooleanObservable} from "../booleanObservable";
import {LayoutOrientation} from "../../../shared/enums/layoutOrientation";
import DateTimePicker from "../../../components/molecules/dateTimePicker/dateTimePicker";
import * as Popper from "@popperjs/core";

export class DateTimePickerRadioGroupKeyValue extends RadioGroupKeyValue {
  dateInput: DateObservable;
  enableDatePicker: BooleanObservable;
  minDate: Date;
  timezone: string;
  helpText: string;
  validationMessage: string;
  position: Popper.Placement;

  constructor(
    value: string,
    label: string,
    dateInput: DateObservable,
    minDate: Date,
    timezone: string,
    enableDatePicker?: boolean,
    tooltip?: string,
    isDisabled?: boolean,
    orientation?: LayoutOrientation,
    helpText: string = "",
    validationMessage: string = "",
    position: Popper.Placement = "auto"
  ) {
    super(value, label, tooltip, isDisabled, "", orientation);
    this.dateInput = dateInput;
    this.enableDatePicker = new BooleanObservable(enableDatePicker ?? false);
    this.minDate = minDate;
    this.timezone = timezone;
    this.helpText = helpText;
    this.validationMessage = validationMessage;
    this.position = position;
  }

  get hasCustomInput(): boolean {
    return true;
  }

  renderCustomInput(isDisabled: boolean): JSX.Element | null {
    return (
      <DateTimePicker
        disabled={isDisabled}
        value={this.dateInput}
        timeZone={this.timezone}
        dateTimePickerErrorMessage={this.validationMessage}
        position={this.position}
      />
    );
  }

  get enteredValue(): string {
    return this.dateInput.date?.toDateString() ?? "N/A";
  }

  setDate(date: Date | null) {
    this.dateInput.setDate(date);
  }
}
